import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const SalesPage = lazy(() => import('@/containers/Views/Sales/SalesPage'));

const SalesRouter = (
  <Route path="sales">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Sales} 
          permissions={EBasicActions.Find}
        >
          <SalesPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default SalesRouter;
